import https from 'https';
import crypto from 'crypto';

function xAppAuth(userId, salt) {
  const pw = `user_autenticado_${userId}`;
  const utf8Buffer = Buffer.from(pw + salt, 'utf8');
  const hash = crypto.createHash('md5');

  hash.update(utf8Buffer);

  return hash.digest('hex');
}

export default function ({ $axios, $toast, store }) {
  $axios.defaults.httpsAgent = new https.Agent({ rejectUnauthorized: false });

  $axios.setBaseURL(process.env.VUE_APP_BASE_URL);

  $axios.onRequest((config) => {
    const token = localStorage.getItem('token');

    if (token != null) {
      config.headers.Authorization = 'Bearer ' + token;

      const user = JSON.parse(localStorage.getItem('user'));
      config.headers['x-app-auth'] = xAppAuth(
        user.id,
        process.env.VUE_APP_AUTH_SALT
      );
    }

    store._vm.$nextTick(() => {
      if (store._vm.$nuxt) {
        store._vm.$nuxt.$loading.start();
        return config;
      }
    });
  });

  $axios.onResponse((response) => {
    store._vm.$nextTick(() => {
      if (store._vm.$nuxt) {
        store._vm.$nuxt.$loading.finish();
      }
    });

    return response;
  });

  $axios.onError((error) => {
    store._vm.$nextTick(() => {
      if (store._vm.$nuxt) {
        setTimeout(() => {});
        store._vm.$nuxt.$loading.finish();
      }
    });
    if (error?.response) {
      if (error.config?.skipErrorToast) {
        return Promise.reject(error);
      }

      const message = error.response?.data?.message;
      const content = error.response?.data?.content;
      if (error.response?.data?.statusCode === 500) return;

      if (!message) {
        if (typeof content === 'string') $toast.error(content);
      } else {
        $toast.error(message);
      }
    }
  });
}
